// React Query hook para cuentas contables externas del proveedor configurado.
// Primer hook del piloto de @tanstack/react-query (ver project_react_query_pilot
// en memoria del proyecto).
//
// Uso:
//   const { data, isLoading, isError, refetch } = useCuentasContablesExternas();
//   data === { configurado: boolean, providerNombre?: string, cuentas: [] }
//
// staleTime alto (1h) porque el PUC del proveedor casi nunca cambia.
// Si el admin acaba de crear una cuenta en Alegra, puede forzar refresh
// llamando a refetch() o invalidando el queryKey desde queryClient.

import { useQuery } from '@tanstack/react-query';
import { listarCuentasContablesExternas } from '../api/finanzas';

const STALE_1_HORA = 1000 * 60 * 60;
const GC_2_HORAS = 1000 * 60 * 60 * 2;

export const QK_CUENTAS_EXTERNAS = ['cuentasContablesExternas'];

export function useCuentasContablesExternas(options = {}) {
  return useQuery({
    queryKey: QK_CUENTAS_EXTERNAS,
    queryFn: async () => {
      const resp = await listarCuentasContablesExternas();
      // El backend devuelve { data: { configurado, cuentas, providerNombre } }
      // request() de http.js devuelve la respuesta axios completa.
      return resp?.data?.data || { configurado: false, cuentas: [] };
    },
    staleTime: STALE_1_HORA,
    gcTime: GC_2_HORAS,
    retry: 1,
    refetchOnWindowFocus: false,
    ...options
  });
}
